import React, { useState, useEffect } from "react";
import { Container } from "reactstrap";
import Breadcrumbs from "../../components/Common/Breadcrumb";

const TraceabilityProductionQc = () => {
  const [machines, setMachines] = useState([]);
  const [selectedMachine, setSelectedMachine] = useState("");
  const [selectedPartId, setSelectedPartId] = useState("");
  const [selectedDate, setSelectedDate] = useState("");
  const [selectedShift, setSelectedShift] = useState("");
  const [data, setData] = useState([]);
  const [searchResult, setSearchResult] = useState(null);
  const [searchLabel, setSearchLabel] = useState("");

  // Fetch Machines
  useEffect(() => {
    fetch("https://api.hanoch.in/api/parts")
      .then((res) => res.json())
      .then((data) => setMachines(data || []))
      .catch((err) => console.error("Error fetching machines:", err));
  }, []);

  // Build API URL for filtering
  const buildFilterUrl = () => {
    let url = "https://api.hanoch.in/api/qc-completed/";
    const params = [];

    if (selectedPartId) params.push(`part_id=${selectedPartId}`);
    if (selectedDate) params.push(`date=${selectedDate}`);
    if (selectedDate && selectedShift) params.push(`shift=${selectedShift}`);

    if (params.length > 0) {
      url += "?" + params.join("&");
    }

    return url;
  };

  // Fetch filtered QC completed
  const fetchQCCompleted = async () => {
    try {
      const url = buildFilterUrl();
      const res = await fetch(url);
      if (!res.ok) throw new Error("Failed to fetch QC completed");
      const result = await res.json();
      setData(result);
      setSearchResult(null); // clear search
    } catch (error) {
      console.error(error);
    }
  };

  // Search by part label
  const searchByPartLabel = async () => {
    if (!searchLabel.trim()) return;
    
    try {
      const res = await fetch(`https://api.hanoch.in/api/search_qc_production/?part_label=${searchLabel}`);
      if (!res.ok) throw new Error("Failed to search part label");
      const result = await res.json();
      setSearchResult(result);
      setData([]); // clear filter results
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <div className="page-content">
      <Container fluid>
        <Breadcrumbs title="OptiMize" breadcrumbItem="Traceability Production QC" />

        {/* Filter Section */}
        <div style={filterBoxStyle} className="container-fluid">
          <div>
            <label>Part:</label>
            <select className="form-control" value={selectedPartId} onChange={(e) => setSelectedPartId(e.target.value)} >
              <option value="">Select Part</option>
              {machines.map((m) => (
                <option key={m.id} value={m.id}>{m.name}</option>
              ))}
            </select>
          </div>

          <div>
            <label>Part ID:</label>
            <input type="number" className="form-control" value={selectedPartId} onChange={(e) => setSelectedPartId(e.target.value)} />
          </div>

          <div>
            <label>Date:</label>
            <input type="date" className="form-control" value={selectedDate} onChange={(e) => setSelectedDate(e.target.value)} />
          </div>

          <div>
            <label>Shift:</label>
            <select className="form-control" value={selectedShift} onChange={(e) => setSelectedShift(e.target.value)}>
              <option value="">Select shift</option>
              <option value="1">6-2 (Shift 1)</option>
              <option value="2">2-10 (Shift 2)</option>
              <option value="3">10-6 (Shift 3)</option>
            </select>
          </div>

          <button className="btn btn-primary" onClick={fetchQCCompleted}>Apply Filter</button>
        </div>

        {/* Search Section */}
        <div style={filterBoxStyle}>
          <input
            type="text"
            className="form-control"
            placeholder="Enter Part Label"
            value={searchLabel}
            onChange={(e) => setSearchLabel(e.target.value)}
          />
          <button className="btn btn-success" onClick={searchByPartLabel}>Search</button>
        </div>

        {/* Results Table */}
        <div style={{ marginTop: "2rem" }}>
          <h5>Results</h5>
          <table className="table table-bordered">
            <thead>
              <tr>
                <th>Part Label</th>
                <th>Part Name</th>
                <th>Date</th>
                <th>Shift</th>
                <th>Operator (Production)</th>
                <th>Operator (QC)</th>
              </tr>
            </thead>
            <tbody>
              {searchResult ? (
                <tr>
                  <td>{searchResult.part_label}</td>
                  <td>{searchResult.part_name}</td>
                  <td>{searchResult.date}</td>
                  <td>{searchResult.shift}</td>
                  <td>{searchResult.production?.operator || "-"}</td>
                  <td>{searchResult.qc?.operator || "-"}</td>
                </tr>
              ) : (
                data.map((item) => (
                  <tr key={item.id}>
                    <td>{item.part_label}</td>
                    <td>{item.part_name}</td>
                    <td>{item.date}</td>
                    <td>{item.shift}</td>
                    <td>{item.operator_name}</td>
                    <td>{item.qc_operator_name || "-"}</td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </Container>
    </div>
  );
};

const filterBoxStyle = {
  display: "flex",
  gap: "10px",
  padding: "10px",
  backgroundColor: "#252b3b",
  color: "#c9d1d9",
  borderRadius: "6px",
  marginTop: "10px",
  flexWrap: "wrap"
};

export default TraceabilityProductionQc;
